(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["maison-appointment"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('maison-appointment')) {
    customElements.define('maison-appointment', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const panel = this.querySelector('details');
        if (this.querySelector('[data-appointment-success], [data-appointment-error]') || location.hash === '#rendez-vous' || location.hash === '#' + this.querySelector('form')?.id) panel.open = true;
        window.addEventListener('hashchange', () => { if (location.hash === '#rendez-vous') panel.open = true; });
        const date = this.querySelector('[data-appointment-date]');
        if (!date) return;
        const time = this.querySelector('[data-appointment-time]');
        const status = this.querySelector('[data-appointment-status]');
        const submit = this.querySelector('[data-appointment-submit]');
        const parisNow = () => {
          const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
          const p = Object.fromEntries(parts.map(x => [x.type, x.value]));
          return { date: `${p.year}-${p.month}-${p.day}`, minutes: Number(p.hour) * 60 + Number(p.minute) };
        };
        const refresh = () => {
          const now = parisNow();
          date.min = now.date;
          const selected = time.value;
          time.replaceChildren(new Option(this.dataset.choose, ''));
          status.textContent = '';
          date.setCustomValidity('');
          time.disabled = true;
          submit.disabled = true;
          if (!date.value) return;
          const weekday = new Date(date.value + 'T12:00:00Z').getUTCDay();
          if (date.value < now.date || weekday === 0) {
            status.textContent = this.dataset.closed;
            date.setCustomValidity(this.dataset.closed);
            return;
          }
          const start = weekday === 1 || weekday === 6 ? 11 : 10;
          const end = weekday === 1 || weekday === 6 ? 19 : 20;
          for (let hour = start; hour < end; hour++) {
            if (date.value === now.date && hour * 60 <= now.minutes) continue;
            const value = `${String(hour).padStart(2, '0')}:00`;
            time.add(new Option(`${value} – ${String(hour + 1).padStart(2, '0')}:00`, value));
          }
          if (time.options.length === 1) {
            status.textContent = this.dataset.closed;
            date.setCustomValidity(this.dataset.closed);
            return;
          }
          time.disabled = false;
          if (Array.from(time.options).some(option => option.value === selected)) time.value = selected;
          submit.disabled = false;
        };
        date.addEventListener('change', refresh);
        this.querySelector('form').addEventListener('submit', event => {
          refresh();
          if (!this.querySelector('form').reportValidity()) event.preventDefault();
        });
        refresh();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
